<template>
    <div ref="request_pay_form_wrap" style="background-color: #fffc; backdrop-filter: blur(100px); display: flex; flex-direction: column;">
        <MercenaryHeader :isBlur="true" :title="'결제하기'" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="margin-top: 80px; flex: 1;">
            <div style="display: flex; flex-direction: column; align-items: center;">
                <img :src="$resourcePath + selectedTeam.image_path" style="width: 80px;">
                <div style="font-weight: 700; font-size: 12px; line-height: 24px; color: #b5aaa3; margin-top: 4px;">{{ selectedTeam.name }}</div>
                <div style="margin-top: 20px;">
                    <div style="font-weight: 500; font-size: 14px; line-height: 21px; text-align: center;">다이렉트 요청서 보내기</div>
                    <div v-if="is_free" style="font-weight: 500; font-size: 20px; line-height: 30px; text-align:center;"><span style="font-weight: 800;">무료</span></div>
                    <div v-else style="font-weight: 500; font-size: 20px; line-height: 30px;"><span style="font-weight: 800;">{{amt | comma}}원</span>을 결제할게요</div>
                </div>
            </div>
        </div>
        <div style="padding: 0 12px;">
            <div @click="checkJoinRequestPayAvailable" style="height: 48px; margin-bottom: 40px; border-radius: 12px; line-height: 48px; background-color: #210f03; text-align: center; color: var(--color-main); font-weight: 700; font-size: 14px;">진행하기</div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ResponseCode from '@/ResponseCode'
import {DIRECT_MESSAGE_REQUEST_PRICE, INNOPAY_MODE} from "../../Constants";
import {INNOPAY_PAY_METHOD} from "../../modules/InnoPay";
import moment from 'moment';

export default {
    name: 'RequestPayForm',
    components: {
        MercenaryHeader
    },
    props: {
        completeAction: {
            type: Function,
            default: () => { }
        },
        selectedTeam: {
            type: Object,
            default: () => { }
        },
        soccerhowIdx: {
            type: [Number, String],
            default: -1
        },
        isFromTeam: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            team: {
                idx: 1,
                manager: {
                    idx: 349362
                }
            },
            phone: '010-6212-8614',
            amt: DIRECT_MESSAGE_REQUEST_PRICE,
            is_free : false,
        }
    },
    methods: {
        async payAction(pay_method, pay_mode, card_idx) {
            //사전 검증
            const before_parameters = {};
            before_parameters.to_member_idx = this.selectedTeam.manager_idx;
            const validation_res = await this.$Axios.get('/api/pay/direct/message/save/before', {params : before_parameters});
            if(validation_res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(validation_res.data.msg);
                return;
            }

            const parameters = {};
            parameters.pay_mode = pay_mode;
            // amt 실제결제금액
            parameters.amt = this.amt;
            parameters.goods_name = '다이렉트 요청서 보내기';
            parameters.card_idx = card_idx;
            // 해당되는 idx
            parameters.to_member_idx = this.selectedTeam.manager_idx;
            parameters.team_idx = this.selectedTeam.idx;

            await this.$Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                return await this.$Axios.post('/api/pay/direct/message/save', converted_parameters);
            }, async (converted_parameters) => {
                const res = await this.$Axios.post('/api/pay/direct/message/save', converted_parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    // this.$GlobalStore.closeModalAll()
                    const payMethodObj = {
                        pay_method: pay_method,
                        goods_name: '다이렉트 요청서 보내기',
                        amt: this.is_free ? 0 : this.amt,
                        pay_info: res.data.pay_info
                    }
                    this.$Util.sendEventClick('다이렉트_요청서_전달', true)
                    let soccerhowIdx = this.isFromTeam ? this.soccerhowIdx : converted_parameters.refer_idx
                    this.$GlobalStore.addModal('CompletePayNew', { payMethodObj: payMethodObj, soccerhowIdx: soccerhowIdx, isModalBackTransparent: true, selectedTeam: this.selectedTeam, completeAction: this.completeAction, isShowPopup: true })
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }, async () => {
                const result = await this.completeAction()
                return [true, { refer_idx: this.isFromTeam ? this.soccerhowIdx : result.data.first_parent_idx }];
            })
        },
        showPayment() {
            if (!this.$Util.checkLogin()) return;

            if(this.is_free){
                this.payAction(INNOPAY_PAY_METHOD.CARD, INNOPAY_MODE.REGISTERED_CARD_PAY, -1);
            }else {
                this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '다이렉트 요청서 보내기', amt: this.amt });
            }
        },
        async checkJoinRequestPayAvailable() {
            // let hi = false

            // if (!hi) {
            //     const result = await this.completeAction()
            //     console.log(result)
            //     return
            // }
            const res = await this.$Axios.get('/api/pay/request/join/check');
            const code = res.data.code;
            if (code === ResponseCode.SUCCESS) {
                this.showPayment();
            } else if (code === 1) {
                const result = await this.completeAction(true)
                this.saveDirectMessageTemporaliy(result)
            } else if (code === 2) {
                this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, completeAction : async () => {
                        const result = await this.completeAction();
                        this.saveDirectMessageTemporaliy(result);
                    }
                })
            }
        },
        async saveDirectMessageTemporaliy(result) {
            // 테스트용
            // this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, step: 5, direct_message_idx: 50, completeAction: this.completeAction })

            const parameters = {};
            parameters.team_idx = this.selectedTeam.idx;
            parameters.to_member_idx = this.selectedTeam.manager_idx;
            parameters.refer_idx = this.isFromTeam ? this.soccerhowIdx : result.data.first_parent_idx
            parameters.phone = this.phone;
            const res = await this.$Axios.post('/api/pay/direct/message/save/temp', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                // res.data.direct_message_idx;
                this.$GlobalStore.addModal('YouthCertificationForm', { isModalBackTransparent: true, step: 5, direct_message_idx: res.data.direct_message_idx, selectedTeam: this.selectedTeam, soccerhowIdx: result.data.first_parent_idx })
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
    },
    mounted(){
        this.$refs.request_pay_form_wrap.parentElement.style.zIndex = 301;
    },
    created() {
        this.payAction = this.$Once(this.payAction);
        this.saveDirectMessageTemporaliy = this.$Once(this.saveDirectMessageTemporaliy)
        this.checkJoinRequestPayAvailable = this.$Once(this.checkJoinRequestPayAvailable)

        if(moment().format('YYYY-MM-DD') < '2099-06-21'){
            this.is_free = true;
        }
    }
}
</script>

<style scoped></style>